import SimpleTooltip from '@rio-cloud/rio-uikit/SimpleTooltip';
import { useIntl } from 'react-intl';

import type { CapacityMetric } from './tourCapacity.ts';

const dimensionMessages: Record<CapacityMetric, { id: string; defaultMessage: string }> = {
    weight: {
        id: 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.capacity.dimension.weight',
        defaultMessage: 'weight',
    },
    loadingMeter: {
        id: 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.capacity.dimension.loading-meter',
        defaultMessage: 'loading meter',
    },
    liter: {
        id: 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.capacity.dimension.volume-liter',
        defaultMessage: 'volume (l)',
    },
    cubicMeter: {
        id: 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.capacity.dimension.volume-cubic-meter',
        defaultMessage: 'volume (m³)',
    },
};

export const CapacityWarning = ({ dimensions }: { dimensions: CapacityMetric[] }) => {
    const intl = useIntl();
    const dimensionLabels = dimensions.map(dimension => intl.formatMessage(dimensionMessages[dimension])).join(', ');
    const warningMessage = intl.formatMessage(
        {
            id: 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.capacity.exceeded',
            defaultMessage: 'Vehicle capacity exceeded: {dimensions}',
        },
        { dimensions: dimensionLabels }
    );

    return (
        <SimpleTooltip content={warningMessage}>
            <span
                aria-label={warningMessage}
                className='display-flex align-items-center justify-content-center flex-0'
                data-testid='capacity-warning'
                role='img'
            >
                <span
                    aria-hidden='true'
                    className='uikit-icon icon-warning-sign text-color-danger text-size-18'
                    data-testid='capacity-warning-icon'
                />
            </span>
        </SimpleTooltip>
    );
};
